module.exports = __webpack_public_path__ + "static/media/thumb.037f5656.svg";